/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/

import * as React from "react";
import PropTypes from "prop-types";
import GenericField from "./fields/GenericField";
import DateTimeField from "./fields/DateTimeField";
import BooleanField from "./fields/BooleanField";
import SelectField from "./fields/SelectField";
import MultiSelectField from "./fields/MultiSelectField";
import SliderField from "./fields/SliderField";
import ColorPickerField from "./fields/ColorPickerField";
import ThermostatSetpointField from "./fields/ThermostatSetpointField";
import LabelField from "./fields/LabelField";

export default class FormField extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  };

  render() {
    const FieldComponent = (() => {
      switch (this.props.type) {
        case "date":
        case "time":
          return DateTimeField;
        case "boolean":
          return BooleanField;
        case "select":
          return SelectField;
        case "multi":
          return MultiSelectField;
        case "range":
          return SliderField;
        case "color":
          return ColorPickerField;
        case "setpoints":
          return ThermostatSetpointField;
        case "label":
          return LabelField;
        default:
          return GenericField;
      }
    })();

    if (FieldComponent) {
      return (
        <div id={this.props.name} data-field-name={this.props.name}>
          <FieldComponent {...this.props} />
        </div>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Form/FormField.jsx